var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLearning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    y: 0.333008,
    width: 59.333,
    height: 59.333,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 38,
    height: 39,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_197_3900",
    transform: "matrix(0.0111111 0 0 0.0108262 0 0.0128205)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_197_3900",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7ElEQVR4nO3cy0oDMRTG8TldKBZ06SOpb1UQX8BLtdSN666kmIiPY7ErLzngbWdkQkGlF6eaZkz9/yDbSTiTnkmZry0KAAAAAAAAjPN2VZw5FrXPovZF1HaLYb9JqSITZzqi1n8ZznRiz/O/qd0SZ97GCq3mse6lLY87uyFqr8eLHAqthfdS9xKXgqg9nVzk0Dr2615fnnyr8WWH6uX25JYRxnW522tdb3Zuz9dFzZk48xpOFc4cFI9Xm6JmMGUnv5V9u/L1h/2mONMuW83UT8ffG06cPSoGvbVodQ5FHi/m/YxFdH99YtFMRrSTlW81Rju56uTztQzfaozO3T7T8RxaapRCq3mqeHfnaxklCv2h7MkV7273h9fv5Ns67EkR9+u1tVFbxmeD3po4exgeMHUXrvp4CIeCmA/DwPdWRE1/esu42Ik74X82bWc70657acta7N3RGfpGnNmL89QFAAAAAGSOXEca5DpSINeRALmONMh1LAK5jgUj1+EnvFki1yFJX86S6/CJik2uQ7IqNLkOP7t1kOvw5DrwDXIdCZHrAAAAAABMRq4jDXIdKZDrSIBcRxrkOhaBXMeCkevw5Dq0tt+Ck+uQtMUm1yFZFZpchyfXobX2Z/6vI3/kOhIi1wEAAAAAAAAAKOb2Dn7LEyzU9/+6AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/learning.a0c174335f8f4ba2d479985101530c7d.svg";
export { ForwardRef as ReactComponent };